import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit, inject } from '@angular/core';
import { AssetDto, GalleryDto } from '@picflow/types';
import { AssetStatusIconPipe } from '../../../gallery/pipes/asset-status-icon.pipe';
import { AssetStatusNamePipe } from '../../../gallery/pipes/asset-status-name.pipe';
import { sleep } from '../../../lib/sleep';
import { StateService } from '../../../services/state.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';

@Component({
  selector: 'app-print-overview',
  templateUrl: './print-overview.component.html',
  styleUrls: ['./print-overview.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingIndicatorComponent, SvgComponent, AssetUrlPipe, AsyncPipe, AssetStatusIconPipe, AssetStatusNamePipe],
})
export class PrintOverviewComponent implements OnInit {
  private state = inject(StateService);
  private check = inject(ChangeDetectorRef);
  assets: AssetDto[];
  gallery: GalleryDto;
  rows: AssetDto[][] = [];
  assetSize: number;
  allAssetsLoaded = false;
  showFilename: boolean;
  showFavorites: boolean;
  showColorlabels: boolean;
  showStatus: boolean;
  thumbnailSize: 'small' | 'medium' | 'large';
  loadedAssets: string[] = [];
  @HostListener('window:keyup', ['$event'])
  keyUpEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') this.close();
  }
  async ngOnInit() {
    this.assets = this.state.printOverview.assets;
    this.gallery = this.state.printOverview.gallery;
    this.showColorlabels = this.state.printOverview.color_labels;
    this.showFavorites = this.state.printOverview.favorites;
    this.showStatus = this.state.printOverview.status;
    this.showFilename = this.state.printOverview.filename;
    this.thumbnailSize = this.state.printOverview.thumbnailSize;

    this.setupPages();
    if (!this.assets.length) this.print();

    this.check.detectChanges();
  }

  close() {
    this.state.printOverview = undefined;
  }

  private getAssetsPerRow() {
    if (this.thumbnailSize === 'large') return 3;
    if (this.thumbnailSize === 'small') return 8;
    return 5;
  }

  private setupPages() {
    this.rows = [];

    const assetsPerRow = this.getAssetsPerRow();
    this.assetSize = 100 / assetsPerRow;
    const assets = this.assets.slice();

    let row: AssetDto[] = [];
    while (assets.length) {
      row.push(assets.shift());

      if (row.length === assetsPerRow) {
        this.rows.push(row);
        row = [];
      }
    }
    if (row.length) this.rows.push(row);
  }

  async assetLoaded(asset: AssetDto) {
    this.loadedAssets.push(asset.id);
    if (this.loadedAssets.length === this.assets.length) {
      this.print();
    }
  }

  async print() {
    this.allAssetsLoaded = true;
    await sleep(20);
    window.print();
    this.close();
  }
}
